module.exports = __webpack_public_path__ + "img/reovat.cdb069de.png";